import { atom } from 'recoil';

export const CanDirectFromHereState = atom({
    key: 'CanDirectFromHereState', 
    default: true, 
});